(function () {
    'use strict';

    var SOD_GRID_FACTORY = 'SodGridFactory';
    var EVENT_LOADING = 'EventLoading';

    angular
        .module('sodCommon')
        .factory('SodGridFactory', SodGridFactory);

    const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.;

    function SodGridFactory($q, $rootScope, lodash, GenericModel) {
        var configSet = {};

        var currentId = null;


        function selectJob(id, job_id) {
            currentId = id;
            if (!job_id) {
                configSet[id].open_detail = false;
                return;
            }
            configSet[id].open_detail = true;
            emitLoadingEvent(true);
            getJobInfo(job_id).then(function(res) {
                configSet[id].selected_job = res.data;
                emitLoadingEvent(false);
            }, function(res) {
                console.error('res', res);
                emitLoadingEvent(false);
            });
        }


        function getFullyFormedDatasource() {
            var urlPath = [currentId, 'datasource', 'get', 'url'].join('.');

            return lodash.get(configSet, urlPath, '');
        }

        function getJobInfo(job_id) {
            var datasource = getFullyFormedDatasource();
            var replacement = {
                id: job_id,
            };
            datasource = decodeURI(datasource).replace(urlReplacerRegex, (match, submatch) => {
                return lodash.get(replacement, submatch, '');
            });
            var model = new GenericModel(datasource);
            return model.get().$promise;

        }

        function emitLoadingEvent(isLoading) {
            $rootScope.$broadcast(
                [SOD_GRID_FACTORY, currentId, EVENT_LOADING].join('.'),
                isLoading
            );
        }

        return function(config) {
            var currentId = lodash.get(config, 'id', 'notExist');
            var isObjectConfig = typeof config === typeof {};

            if (!lodash.has(configSet, currentId) && isObjectConfig) {
                var configSetObject = {};
                configSetObject[currentId] = config;
                configSet = Object.assign({}, configSet, configSetObject);
            }

            function init() {

            }

            init();

            return {
                eventPrefix: SOD_GRID_FACTORY,
                eventLoading: EVENT_LOADING,
                selectJob: selectJob
            };
        };
    }
})();